import { useAuthStore } from '@/stores/auth';
import { pinia } from '@/stores/pinia';
import { isMissingBearerToken, sessionEndedError } from '../sessionEnded';

function trimFields(obj, depth = 0, seen = new WeakSet()) {
	if (depth > 50 || seen.has(obj)) {
		return;
	}
	seen.add(obj);

	for (const key in obj) {
		if (typeof obj[key] === 'string' && obj[key].length <= 100) {
			obj[key] = obj[key].trim();
		} else if (typeof obj[key] === 'object' && obj[key] !== null) {
			trimFields(obj[key], depth + 1, seen);
		}
	}
}

export default {
	request: {
		name: 'Trim fields and check session',
		config: (config) => {
			const authStore = useAuthStore(pinia);
			if (authStore.isSessionExpired()) {
				authStore.AUTH_LOGOUT();
				return Promise.reject({ message: 'Session expired' });
			}

			// Logout clears the token synchronously while the dashboard is still
			// mounted, so a load already under way - or one a claim-gated remount
			// kicks off on the way out - arrives here with an empty bearer. Never
			// dispatch it: the 401 it would earn gets reported by the caller as a
			// failure toast on the login screen. QGEN-5569.
			if (isMissingBearerToken(config)) {
				return Promise.reject(sessionEndedError(config));
			}

			if (config.data && typeof config.data === 'object') {
				trimFields(config.data);
			}
			return config;
		},
		error: function (error) {
			return Promise.reject(error);
		},
	},
};
